import { MinzeElement } from 'minze'

export interface LvcPinIcon {}

export class LvcPinIcon extends MinzeElement {
  html = () => `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.72202 3.49165C7.19315 4.28275 5.85867 5.7237 4.97942 7.61896C2.72754 12.473 8.62604 18.4289 12.0785 21C13.9396 19.5687 22.3464 12.1698 18.5432 6.56382C16.1612 3.05255 12.4253 2.26697 9.33227 3.6335M12.4838 8.07426C13.0231 8.15547 13.4575 8.42369 13.7374 8.78459C14.0173 9.1455 14.2037 9.56714 14.2807 10.0136C14.346 10.452 14.2574 10.8991 14.0294 11.2822C13.8014 11.6652 13.4474 11.9616 13.025 12.1231C12.5954 12.2626 12.1352 12.2861 11.6931 12.1911C11.251 12.0961 10.8434 11.8861 10.5135 11.5835C10.1603 11.2594 9.92607 10.8309 9.84669 10.364C9.76731 9.89716 9.84723 9.41774 10.0741 8.99956C10.3011 8.58139 10.6624 8.24765 11.1026 8.0497C11.469 7.88488 11.9411 7.81845 12.3533 7.86911" stroke="#1E007D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `

  css = () => `
    
  `
}
